import { gsap } from "gsap";
import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { DollarsResourcePackage } from "../../../common/resources/DollarsResourcePackage";
type TimeLine = gsap.core.Timeline;

export class DynamicBackground extends Container {
    private readonly ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>();
    private readonly referenceWidth: number;
    private readonly referenceHeight: number;
    private dollarIcons: Array<Sprite>;
    private iconIdleAnimation: TimeLine;

    public constructor(
        dollarsResources: DollarsResourcePackage,
        referenceWidth: number,
        referenceHeight: number
    ) {
        super();
        this.referenceWidth = referenceWidth;
        this.referenceHeight = referenceHeight;
        this.iconIdleAnimation = new gsap.core.Timeline();
        this.ICONS_VIEW_DESCRIPTION = new Array<IconViewDescription>(
            { percentPosition: new Point(0.074879227, 0.691964286), texture: dollarsResources.assets_views_dollars_1_copy_png, size: new Point(123.33, 169.3) },
            { percentPosition: new Point(-0.19, 0.53), texture: dollarsResources.assets_views_dollars_5_copy_png, angle: -64.86, size: new Point(227.72, 302.12) },
            { percentPosition: new Point(0.05, 0.17), texture: dollarsResources.assets_views_dollars_2_copy_png, angle: -10.31, size: new Point(127.27, 199.55) },
            { percentPosition: new Point(0.27, 0.02), texture: dollarsResources.assets_views_dollars_7_copy_png, size: new Point(69, 101) },
            { percentPosition: new Point(0.46, 0.09), texture: dollarsResources.assets_views_dollars_4_copy_png, size: new Point(88.09, 158.56) },
            { percentPosition: new Point(0.76, 0.05), texture: dollarsResources.assets_views_dollars_3_copy_png, size: new Point(63, 80) },
            { percentPosition: new Point(0.78, 0.17), texture: dollarsResources.assets_views_dollars_6_copy_png, angle: -14.92, size: new Point(157.24, 158.45) },
            { percentPosition: new Point(0.82, 0.4), texture: dollarsResources.assets_views_dollars_5_copy_png, size: new Point(202, 268) },
            { percentPosition: new Point(0.76, 0.68), texture: dollarsResources.assets_views_dollars_7_copy_png, size: new Point(132, 168) }
        );
        this.dollarIcons = [];
        this.build();
    }

    private build(): void {
        this.ICONS_VIEW_DESCRIPTION.forEach((item) => {
            const icon = new Sprite(item.texture);
            icon.width = item.size.x;
            icon.height = item.size.y;
            if (item.angle) {
                icon.angle = item.angle;
            }
            icon.position.set(this.referenceWidth * item.percentPosition.x - this.referenceWidth * 0.5, this.referenceHeight * item.percentPosition.y - this.referenceHeight * 0.5);
            this.dollarIcons.push(icon);
            this.addChild(icon);
        });
    }

    public async playIdleAnimation(): Promise<void> {
        this.dollarIcons.forEach((icon) => {
            this.iconIdleAnimation.to(icon, {
                x: "+=25",
                y: `random(${icon.y - 20}, ${icon.y + 20}, 1)`,
                duration: "random(1.5, 2)",
                delay: "random(0, 0.2)",
                repeat: -1,
                repeatRefresh: true,
                yoyo: true,
                ease: "sine.inOut"
            }, "<");
        });
        await this.iconIdleAnimation.play();
        this.iconIdleAnimation.clear();
    }

    public hide(): void {
        this.iconIdleAnimation.pause(0);
        this.iconIdleAnimation.clear();
        this.visible = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.iconIdleAnimation.kill();
        super.destroy(options);
    }
}

type IconViewDescription = {
    percentPosition: Point;
    texture: Texture;
    angle?: number;
    size: Point;
}
